<template>
	<div class="content-wrapper">
		<!-- Content -->
		<div class="container-xxl flex-grow-1 container-p-y" v-if="employee">
			<!-- Header -->
			<div class="row">
				<div class="col-12">
					<div class="card mb-6">
						<div class="user-profile-header-banner">
							<img src="https://demos.pixinvent.com/materialize-html-laravel-admin-template/demo/assets/img/pages/profile-banner.png" alt="Banner image" class="rounded-top" />
						</div>
						<div class="user-profile-header d-flex flex-column flex-sm-row text-sm-start text-center mb-5">
							<div class="flex-shrink-0 mt-n2 mx-sm-0 mx-auto">
								<img
									:src="`https://ui-avatars.com/api/?name=${employee.firstName}+${employee.lastName}&background=666cff&color=fff`"
									alt="user image"
									class="d-block h-auto ms-0 ms-sm-5 rounded-4 user-profile-img" />
							</div>
							<div class="flex-grow-1 mt-4 mt-sm-12">
								<div
									class="d-flex align-items-md-end align-items-sm-start align-items-center justify-content-md-between justify-content-start mx-5 flex-md-row flex-column gap-6">
									<div class="user-profile-info">
										<h4 class="mb-2">{{ employee.firstName }} {{ employee.lastName }}</h4>
										<ul
											class="list-inline mb-0 d-flex align-items-center flex-wrap justify-content-sm-start justify-content-center gap-4">
											<li class="list-inline-item" v-if="employee.tcaNumber">
												<i class="ri-id-card-line me-2 ri-24px"></i><span class="fw-medium">{{ employee.tcaNumber }}</span>
											</li>
											<li class="list-inline-item" v-if="employee.jobName">
												<i class="ri-file-user-line me-2 ri-24px"></i
													><span class="fw-medium"> {{ employee.jobName }} </span>
											</li>
										</ul>
									</div>
									<a href="javascript:void(0)" class="btn btn-primary" @click="showEditUserModal()">
										<i class="ri-user-follow-line ri-16px me-2"></i>
										{{ $t('common.actions.edit') }}
									</a>
									<!-- <a href="javascript:void(0)" class="btn btn-primary">
										<i class="ri-link-m ri-16px me-2"></i>
										Telecharger attestations
									</a> -->
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!--/ Header -->
			<!-- Navbar pills -->
			<!--/ Navbar pills -->
			<!-- User Profile Content -->
			<div class="row">
				<div class="col-xl-12 col-lg-12 col-md-12">
					<div class="card mb-6" >
						<div class="table-responsive">
							<table id="example" class="table datatable-project table-border-bottom-0" style="width:100%">
								<thead>
									<tr>
										<th>{{ $t('employees.profile.training') }}</th>
										<th>{{ $t('employees.profile.type') }}</th>
										<th>{{ $t('employees.profile.state') }}</th>
										<th>{{ $t('employees.profile.expiration') }}</th>
										<th>{{ $t('common.fields.actions') }}</th>
									</tr>
								</thead>
								<tbody>
									<tr class="odd" v-for="(training, index) in formattedTrainings" :key="index">
										<td class=" control" tabindex="0" style="display: none;"></td>
										<td class="sorting_1">
												<div class="d-flex justify-content-left align-items-center">
													<div class="avatar-wrapper">
														<div class="avatar avatar me-4" v-if="training.category === 'official'">
															<span class="avatar-initial rounded-circle bg-label-primary">
																<i class="ri-flight-takeoff-line"></i>
															</span>
														</div>
														<div class="avatar avatar me-4" v-else>
															<span class="avatar-initial rounded-circle bg-label-secondary">
																<i class="ri-question-mark"></i>
															</span>
														</div>
													</div>
													<div class="d-flex flex-column">
														<span class="text-truncate fw-medium text-heading">
															{{ training.formationTitle ? training.formationTitle : training.formationName }}
														</span>
														<small>{{ formatRelativeDate(training.createdAt) }}</small>
													</div>
												</div>
										</td>
										<td>
											<span class="text-heading">
												<span v-if="training.type === 'renewal'">
													{{ $t('common.trainingTypes.renewal') }}
												</span>
												<span v-else>
													{{ $t('common.trainingTypes.initial') }}
												</span>
											</span>
										</td>
										<td>
											<span class="text-heading">
												<span class="badge rounded-pill me-1" :class="training.statusInfo.color">
													{{ training.statusInfo.title }}
												</span>
											</span>
										</td>
										<td>
											<span v-if="training.expiredAt">{{ formatDate(training.expiredAt) }}</span>
											<span v-if="!training.expiredAt">{{ $t('employees.profile.notFinished') }}</span>
										</td>
										<td>
											<a href="javascript:void(0);" class="btn btn-sm btn-icon btn-text-secondary rounded-pill me-1 waves-effect waves-light" @click="downloadCertificate(training._id)" 
											v-if="training.category !== 'custom' && training.status === 'succeeded'">
												<i class="ri-file-download-fill ri-22px"></i>
											</a>
											<a href="javascript:void(0);" class="btn btn-sm btn-icon btn-text-secondary rounded-pill me-1 waves-effect waves-light" v-if="training.category === 'custom'" @click="deleteTraining(training._id)">
												<i class="ri-delete-bin-6-line ri-22px"></i>
											</a>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
				<!--/ User Profile Content -->
			</div>

			<!-- ADD Training -->
			<div class="modal fade" id="addTraining" tabindex="-1" aria-hidden="true" v-show="employee">
				<div class="modal-dialog modal-dialog-centered1 modal-simple modal-add-new-cc">
					<div class="modal-content">
						<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
						<div class="modal-body p-0">
							<div class="text-center mb-6">
								<h4 class="mb-2">{{ $t('employees.profile.addTrainingFor') }}</h4>
								<p>{{ employee.firstName }} {{ employee.lastName }}</p>
							</div>

							<form id="addTrainingForm" class="row g-5" onsubmit="return false">
								<div class="col-12">
									
									<div class="form-floating form-floating-outline">

										<select id="defaultSelect" class="form-select" v-model="trainingForm.trainingName">
											<option disabled value="">{{ $t('employees.profile.selectTraining') }}</option>
											<option v-for="training in trainingsList" :key="training" :value="training">
												{{ training }}
											</option>
										</select>
										<label>{{ $t('employees.profile.trainingName') }}</label>
									</div>

								</div>
								<div class="col-12 col-md-6">
									<div class="col-md-12 col-12 mb-6">
										<div class="form-floating form-floating-outline">
											<input type="text" id="bs-datepicker-basic" placeholder="MM/DD/YYYY" class="form-control" ref="startDate" v-model="trainingForm.startDate" />
											<label for="bs-datepicker-basic">{{ $t('employees.profile.obtainedDate') }}</label>
										</div>
									</div>
								</div>

								<div class="col-12 col-md-6">
									<div class="col-md-12 col-12 mb-6">
										<div class="form-floating form-floating-outline">
											<input type="text" id="bs-datepicker-basic" placeholder="MM/DD/YYYY" class="form-control" ref="expireDate" v-model="trainingForm.expireDate" />
											<label for="bs-datepicker-basic">{{ $t('employees.profile.expirationDate') }}</label>
										</div>
									</div>
								</div>
								
								<div class="col-12 mt-0">
									<div class="form-check form-switch">
										<input type="checkbox" class="form-check-input" id="appFutureAddress" checked v-model="trainingForm.firstTraining" />
										<label for="appFutureAddress" class="text-heading">
											{{ $t('employees.profile.isInitialTraining') }}
										</label>
									</div>
								</div>

								<div class="col-12 mt-0">
									<div class="form-check form-switch">
										<input type="checkbox" class="form-check-input" id="appFutureAddress" v-model="trainingForm.remindExpiration" />
										<label for="appFutureAddress" class="text-heading">
											{{ $t('employees.profile.remindExpiration') }}
										</label>
									</div>
								</div>

								<div class="col-12 d-flex flex-wrap justify-content-center gap-4 row-gap-4">
									<button type="submit" class="btn btn-primary" @click="saveCustomTraining()">{{ $t('common.actions.save') }}</button>
									<button
										type="reset"
										class="btn btn-outline-secondary btn-reset"
										data-bs-dismiss="modal"
										aria-label="Close">
										Cancel
									</button>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>

			<!-- EDIT USER -->
			<div class="modal fade" id="editUser" tabindex="-1" aria-hidden="true" v-show="employee">
				<div class="modal-dialog modal-dialog-centered1 modal-simple modal-add-new-cc">
					<div class="modal-content">
						<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
						<div class="modal-body p-0">
							<div class="text-center mb-6">
								<h4 class="mb-2">{{ $t('employees.profile.editTitle', { firstName: employee.firstName, lastName: employee.lastName }) }}</h4>
							</div>

							<form id="addTrainingForm" class="row g-5" onsubmit="return false">
								<div class="col-12">
									<div class="form-floating form-floating-outline">
										<input
											type="email"
											id="modalEditUserFirstName"
											name="modalEditUserFirstName"
											class="form-control"
											value="11.2"
											v-model="employee.email" />
										<label for="modalEditUserFirstName">{{ $t('common.fields.email') }}</label>
									</div>
								</div>

								<div class="col-12">
									<div class="form-floating form-floating-outline">
										<input
											type="text"
											id="modalEditUserFirstName"
											name="modalEditUserFirstName"
											class="form-control"
											value="11.2"
											:placeholder="$t('employees.profile.tcaNumber')" v-model="employee.tcaNumber" />
										<label for="modalEditUserFirstName">{{ $t('employees.profile.tcaNumber') }}</label>
									</div>
								</div>

								<div class="col-12">
									<div class="form-floating form-floating-outline">
										<input
											type="text"
											id="modalEditUserFirstName"
											name="modalEditUserFirstName"
											class="form-control"
											value="11.2"
											placeholder="Vendeur" v-model="employee.jobName" />
										<label for="modalEditUserFirstName">{{ $t('employees.profile.jobName') }}</label>
									</div>
								</div>

								<div class="col-12 d-flex flex-wrap justify-content-center gap-4 row-gap-4">
									<button type="submit" class="btn btn-primary" @click="saveEmployeeProfile()">{{ $t('common.actions.save') }}</button>
									<button
										type="reset"
										class="btn btn-outline-secondary btn-reset"
										data-bs-dismiss="modal"
										aria-label="Close">
										Cancel
									</button>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>

			<div
				class="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-6">
				<div class="d-flex align-content-center flex-wrap gap-4">
					<router-link to="/employees/list">
						<button class="btn btn-outline-secondary">{{ $t('common.actions.back') }}</button>
					</router-link>
				</div>
				<button type="button" class="btn btn-primary" @click="resetTrainingForm()" data-bs-toggle="modal" data-bs-target="#addTraining">
					{{ $t('employees.profile.addTraining') }}
				</button>
			</div>
			<!-- / Content -->
			<div class="content-backdrop fade"></div>
		</div>
	</div>
</template>
<script>
import HTTP from "@/axios";
import moment from "moment";
import "moment/locale/fr";

import flatpickr from "flatpickr";
import "flatpickr/dist/flatpickr.min.css"; // Style Flatpickr

import "@/assets/vendor/css/pages/page-profile.css";

// eslint-disable-next-line no-unused-vars
import { getStatusInfo } from "@/helpers/statusHelper";

moment.locale(localStorage.getItem('locale') || 'fr');

export default {
	name: "ProfileView",

	data() {
		return {
			employee: null,
			trainings: [],

			trainingsList: [
				"11.2.2",
				"11.2.2 (11.2.5)",
				"11.2.3.6",
				"11.2.3.6+TCA",
				"11.2.3.7",
				"11.2.3.7+TCA",
				"11.2.3.8",
				"11.2.3.8+TCA",
				"11.2.3.9",
				"11.2.3.9+TCA",
				"11.2.3.10",
				"11.2.3.10+TCA",
				"11.2.6.2",
				"11.2.7",
				"11.2.8",
				"11.2.3.11",
				"11.2.3.11+TCA",
				"11.2.5",
				"11.2.5",
				"11.2.3.3",
				"11.2.3.3 CVFM",
				"Permis Piéton MAN/TRA",
				"Permis T",
				"Permis P"
			],
			trainingForm: {
				trainingName: "",
				startDate: "",
				expireDate: "",
				firstTraining: false,
				remindExpiration: false
			}
		};
	},

	computed: {
		// Retourne le statut formaté pour l'affichage
		formattedTrainings() {
			return this.trainings.map((training) => {
				return {
					...training,
					statusInfo: getStatusInfo(training.status)
				};
			});
		}
	},

	methods: {
		initDatepicker() {
			this.$nextTick(() => {
				if (this.$refs.startDate) {
					flatpickr(this.$refs.startDate, {
						dateFormat: "d/m/Y",
					});
				} else {
					console.error("Ref 'startDate' is not available.");
				}
				if (this.$refs.expireDate) {
					flatpickr(this.$refs.expireDate, {
						dateFormat: "d/m/Y",
					});
				} else {
					console.error("Ref 'expireDate' is not available.");
				}
			});
		},

		formatRelativeDate(date) {
			return moment(date).fromNow(); // Affiche "il y a 3 semaines"
		},

		formatDate(date) {
			return moment(date).format("DD/MM/YYYY"); // Affiche "il y a 3 semaines"
		},

		resetTrainingForm() {
			this.trainingForm = {
				trainingName: "",
				startDate: "",
				expireDate: "",
				firstTraining: false,
				remindExpiration: false
			};

			// Les champs de date sont pilotés par flatpickr : vider le modèle ne suffit pas
			this.$refs.startDate?._flatpickr?.clear();
			this.$refs.expireDate?._flatpickr?.clear();
		},

		async saveCustomTraining() {
			const employeeId = this.employee._id;

			try {
				await HTTP.post('/trainings/create-custom-training', { ...this.trainingForm, employeeId });

				// Hide modal
				const modal = window.bootstrap.Modal.getInstance(document.getElementById("addTraining"));
				if (modal) {
					modal.hide();
				}

				// Clean
				setTimeout(() => {
					document.querySelectorAll('.modal-backdrop').forEach(el => el.remove());
					document.body.style.overflow = '';
					document.body.style.paddingRight = '';
					document.body.classList.remove('modal-open');
				}, 500)

				// Reload 
				this.fetchEmployeeTrainings(employeeId);

				this.resetTrainingForm();
			} catch (error) {
				// Récupérer le message d'erreur de l'API ou définir un message par défaut
				const errorMessage = error?.response?.data?.message || this.$t('errors.generic');

				alert(errorMessage);

				// Log détaillé dans la console (utile en développement)
				console.error("Erreur API:", error);
			}
		},

		showEditUserModal() {
			const modalElement = document.getElementById("editUser");
			let modal = window.bootstrap.Modal.getInstance(modalElement);

			if (!modal) {
				modal = new window.bootstrap.Modal(modalElement);
			}

			modal.show();
		},

		async downloadCertificate(trainingId) {
			try {
				// Appel API pour récupérer le PDF en base64
				const response = await HTTP.post(`/certificates/download`, { trainingId });

				if (response.data?.base64) {
					// Convertir la base64 en un Blob et créer un lien de téléchargement
					const byteCharacters = atob(response.data.base64);
					const byteNumbers = new Array(byteCharacters.length);
					for (let i = 0; i < byteCharacters.length; i++) {
						byteNumbers[i] = byteCharacters.charCodeAt(i);
					}
					const byteArray = new Uint8Array(byteNumbers);
					const blob = new Blob([byteArray], { type: 'application/pdf' });

					// Créer un lien pour le téléchargement
					const link = document.createElement('a');
					link.href = URL.createObjectURL(blob);
					link.download = `attestation_${trainingId}.pdf`;
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
				} else {
					throw new Error("Fichier non disponible.");
				}
			} catch (error) {
				// Gestion des erreurs
				const errorMessage = error?.response?.data?.message || 
					this.$t('errors.generic');
				alert(errorMessage);
				console.error("Erreur API:", error);
			}
		},

		async saveEmployeeProfile() {
			try {
				await HTTP.put(`/company/employees/${this.employee._id}`, {
					email: this.employee.email,
					jobName: this.employee.jobName,
					tcaNumber: this.employee.tcaNumber ? this.employee.tcaNumber : "",
				});

				// Hide modal
				const modal = window.bootstrap.Modal.getInstance(document.getElementById("editUser"));
				if (modal) {
					modal.hide();
				}
			} catch (error) {
				// Récupérer le message d'erreur de l'API ou définir un message par défaut
				const errorMessage = error?.response?.data?.message || this.$t('errors.generic');

				alert(errorMessage);

				// Log détaillé dans la console (utile en développement)
				console.error("Erreur API:", error);
			}
		},

		async fetchEmployeeTrainings(employeeId) {
			try {
				const response = await HTTP(`/company/employees/${employeeId}`);
				this.employee = response.data.employee;
				this.trainings = response.data.trainings;

				this.initDatepicker();
			} catch (error) {
				// Récupérer le message d'erreur de l'API ou définir un message par défaut
				const errorMessage = error?.response?.data?.message || this.$t('errors.generic');

				alert(errorMessage);

				// Log détaillé dans la console (utile en développement)
				console.error("Erreur API:", error);
			}
		},

		async deleteTraining(trainingId) {
			if (!confirm(this.$t('confirm.deleteTraining')))
				return;

			try {
				await HTTP.delete("/trainings/" + trainingId);
				this.fetchEmployeeTrainings(this.employee._id);
			} catch (error) {
				// Gestion des erreurs
				const errorMessage = error?.response?.data?.message || this.$t('errors.generic');
				alert(errorMessage);
				console.error("Erreur API:", error);
			}
		},
	},

	async mounted() {
		const employeeId = this.$route.params.employeeId;
		this.fetchEmployeeTrainings(employeeId);
	}
};
</script>

<style scoped>
/* Ajoutez des styles spécifiques à la page Dashboard */
.user-profile-header-banner img {
	height: 150px;
}
</style>
